import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, Button, Chip } from '@mui/material';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useCotizacionStore } from '../store/cotizacionStore';

const estadoColors: Record<string, 'success' | 'warning' | 'error' | 'default'> = {
  APR: 'success', PEN: 'warning', ANU: 'error', CON: 'success',
};
const estadoLabels: Record<string, string> = {
  APR: 'Aprobada', PEN: 'Pendiente', ANU: 'Anulada', CON: 'Convertida',
};

export const CotizacionesPage: React.FC = () => {
  const navigate = useNavigate();
  const { cotizaciones, loading, fetchCotizaciones } = useCotizacionStore();

  useEffect(() => { fetchCotizaciones(); }, [fetchCotizaciones]);

  const columns: GridColDef[] = [
    { field: 'numero', headerName: 'Número', width: 120 },
    {
      field: 'fechaCotizacion', headerName: 'Fecha', width: 120,
      valueFormatter: (value: string) => { try { return format(new Date(value), 'dd/MM/yyyy', { locale: es }); } catch { return value; } },
    },
    { field: 'persona', headerName: 'Cliente', flex: 1, minWidth: 200, valueGetter: (value: any) => value?.personaContacto || '-' },
    { field: 'vendedor', headerName: 'Vendedor', width: 150, valueGetter: (value: any) => value?.usuario || '-' },
    { field: 'total', headerName: 'Total', width: 120, type: 'number', valueFormatter: (value: number) => `S/ ${(value ?? 0).toFixed(2)}` },
    {
      field: 'estado', headerName: 'Estado', width: 120,
      renderCell: (params) => <Chip label={estadoLabels[params.value] || params.value || '-'} color={estadoColors[params.value] || 'default'} size="small" />,
    },
    { field: 'fechaValidez', headerName: 'Válida hasta', width: 120,
      valueFormatter: (value: string) => { if (!value) return '-'; try { return format(new Date(value), 'dd/MM/yyyy', { locale: es }); } catch { return value; } },
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight="bold">Cotizaciones</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/ventas/cotizaciones/nueva')}>Nueva Cotización</Button>
      </Box>
      <Paper sx={{ height: 600 }}>
        <DataGrid
          rows={cotizaciones} columns={columns} getRowId={(row) => row.idCotizacion}
          loading={loading} pageSizeOptions={[10, 20, 50]} initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
          onRowClick={(params) => navigate(`/ventas/cotizaciones/${params.row.idCotizacion}`)}
          sx={{ cursor: 'pointer', border: 'none' }} disableRowSelectionOnClick
        />
      </Paper>
    </Box>
  );
};
